import React, { FC, ReactElement } from 'react'

import { FormattedMessage } from 'react-intl'

import { Colors } from 'common-constants/colors'
import { Button, SecondaryButton } from 'components/presentational/button'
import UniNoticeViewContent from 'components/uninotice/UniNoticeViewContent'

import { LastPhotoSvg } from './PhotoViewerNoticeIndex.styled'

export const PhotoViewerNoticeIndex: FC<{
  title?: ReactElement
  onSendGift: () => void
  onSendMessage: () => void
}> = ({ title, onSendGift, onSendMessage }) => {
  return (
    <UniNoticeViewContent
      title={title}
      noticeId="last-photo"
      textComponent={
        <FormattedMessage
          id="last.messenger.text"
          defaultMessage="Отправьте Комплимент, чтобы обратить на себя внимание или напишите сообщение прямо сейчас"
        />
      }
      imageComponent={<LastPhotoSvg />}
      primaryComponent={
        <Button
          onClick={onSendGift}
          data-name="notice-last-photo-send-gift-action"
        >
          <FormattedMessage
            id="send.gift"
            defaultMessage="Отправить Комплимент"
          />
        </Button>
      }
      secondaryComponent={
        <SecondaryButton
          onClick={onSendMessage}
          data-name="notice-last-photo-send-message-action"
        >
          <FormattedMessage
            id="photo_rating.match_modal.button"
            defaultMessage="Написать сообщение"
          />
        </SecondaryButton>
      }
      color={Colors.white}
      inline={true}
      gradient={false}
    />
  )
}
